import React, { useRef, useState } from 'react';

/**
 * Composant SubNavbar réutilisable pour maintenir la cohérence des bordures et espacements
 * @param {React.ReactNode} children - Contenu à afficher dans la subnavbar
 * @param {boolean} sticky - Si true, la subnavbar reste fixe en haut lors du scroll
 * @param {string} className - Classes CSS additionnelles
 */
const SubNavbar = ({ children, sticky = true, className = '' }) => {
  const scrollContainerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleWheel = (e) => {
    const container = scrollContainerRef.current;
    if (container && e.deltaY !== 0) {
      // Vérifier si le contenu dépasse la largeur visible
      const hasHorizontalScroll = container.scrollWidth > container.clientWidth;
      if (hasHorizontalScroll) {
        e.preventDefault();
        container.scrollLeft += e.deltaY;
      }
    }
  };

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsDragging(true);
      setStartX(e.pageX - container.offsetLeft);
      setScrollLeft(container.scrollLeft);
      container.style.cursor = 'grabbing';
      container.style.userSelect = 'none';
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const container = scrollContainerRef.current;
    if (container) {
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2; // Multiplier pour un scroll plus rapide
      container.scrollLeft = scrollLeft - walk;
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    const container = scrollContainerRef.current;
    if (container) {
      container.style.cursor = 'grab';
      container.style.userSelect = '';
    }
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    const container = scrollContainerRef.current;
    if (container) {
      container.style.cursor = 'grab';
      container.style.userSelect = '';
    }
  };

  return (
    <div
      className={`w-full bg-white border-b border-gray-100 ${sticky ? 'sticky top-[70px] z-20' : ''} ${className}`}
    >
      <div 
        ref={scrollContainerRef}
        className="px-2 tab:px-4 lg:px-4 h-[64px] flex items-end overflow-x-auto overflow-y-visible cursor-grab active:cursor-grabbing no-scrollbar" 
        style={{ WebkitOverflowScrolling: 'touch' }}
        onWheel={handleWheel}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
      >
        <div className="flex items-end gap-3 whitespace-nowrap min-w-max w-full justify-between overflow-visible h-full">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SubNavbar;

